<div class="dialog-shell" style="min-width: 350px;">
  <div class="dialog-header">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-exclamation-triangle text-3xl text-yellow-500" *ngIf="confirmStatus === 'warning'"></i>
      <i class="pi pi-info-circle text-3xl text-blue-500" *ngIf="confirmStatus === 'primary'"></i>
      <i class="pi pi-times-circle text-3xl text-red-500" *ngIf="confirmStatus === 'danger'"></i>
      <i class="pi pi-check-circle text-3xl text-green-500" *ngIf="confirmStatus === 'success'"></i>
      <span class="dialog-title">{{ title }}</span>
    </div>
    <p-button icon="pi pi-times" [text]="true" severity="secondary" (onClick)="cancel()"></p-button>
  </div>

  <div class="dialog-body">
    <p class="m-0 text-color-secondary line-height-3">{{ message }}</p>
  </div>

  <div class="dialog-footer">
    <button pButton label="Cancel" class="p-button-text p-button-secondary" (click)="cancel()"></button>
    <button pButton [label]="confirmText" [severity]="getSeverity(confirmStatus)" (click)="close(true)"
      autofocus></button>
  </div>
</div>
